import axios from 'axios'
import { accessToken } from './useSessionData'
import { isStorybook } from './useEnv'

// axios.defaults.baseURL = '/api/v2/' // should be from env variable
axios.defaults.baseURL = (import.meta.env.DEV && !isStorybook) ? 'http://localhost:8001/api/v2/' : '/api/v2/'
axios.defaults.headers.common.Authorization = `Token ${accessToken}`
axios.defaults.headers.common['Teamup-Request-Mode'] = 'customer'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common.Accept = 'application/json'

const instance = axios.create()

export const useAxios = () => instance
